import Icon from 'veui/components/Icon'
import { IconBarChart } from 'dls-icons-vue'

Icon.register('bar-chart', IconBarChart)
